import { UI_PRIMITIVE__checkbox } from '@/components/ui/UI_PRIMITIVE__checkbox';
import { use_dispatch } from '@/hooks/_base/use_dispatch';
import { remote_workspace_user_update_permissions } from '@/state/workspace/user/remote_workspace_user_update_permissions';
import { try_add_required_permissions, try_delete_inherited_permissions } from '@/utils/utils_client_workspace_user_permissions';
import { DTO__workspace_user } from '@shared/dto/+workspace/workspace_user/DTO__workspace_user';

interface Props {
  user: DTO__workspace_user;
  feature: string;
}

export const WSFeaturesCheckbox: React.FC<Props> = ({ user, feature }) => {
  const dispatch = use_dispatch();

  async function onClick() {
    if (user.is_feature_pertmitted(feature)) {
      user.permissions = try_delete_inherited_permissions(feature, user.permissions);

      user = user.clone({ permissions: user.permissions.filter(item => item != feature) });
    } else {
      user.permissions = try_add_required_permissions(feature, user.permissions);

      user = user.clone({ permissions: [...user.permissions, feature] });
    }

    await dispatch(remote_workspace_user_update_permissions(user));
  }

  return <UI_PRIMITIVE__checkbox checked={user.is_feature_pertmitted(feature)} onClick={onClick} />;
};
